import * as React from 'react';
import './radio.scss';

interface Props {
  checked: (name: string, value: string) => void;
  text?: string;
  radioName: string;
  value?: string;
  isChecked?: boolean;
  disabled?: boolean;
  containerStyle?: React.CSSProperties;
  circleStyle?: React.CSSProperties;
}

const RadioButton: React.FC<Props> = ({
  checked,
  text,
  radioName,
  value,
  isChecked,
  disabled,
  containerStyle,
  circleStyle,
}) => {
  const onClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    checked(event.target.name, event.target.value);
  };
  return (
    <>
      <label className={`radio-button ${disabled ? 'radio-button--disabled' : ''}`} style={containerStyle}>
        <input
          type="radio"
          name={radioName}
          onChange={onClick}
          value={value}
          checked={isChecked}
          disabled={disabled}
          style={circleStyle}
        />
        <span className="radio-button__checkmark"></span>
        <div className="radio-button__itemText"> {text} </div>
      </label>
    </>
  );
};
export default RadioButton;
